import { useCallback, useState } from 'react';

const DEFAULT_PAGE_SIZES = [12, 24, 36, 48, Number.MAX_SAFE_INTEGER];

interface UsePaginationProps {
    initialPage?: number;
    initialPageSize?: number;
}

interface UsePaginationReturn {
    currPage: number;
    setCurrPage: (newCurrPage: number) => void;
    resetCurrPage: () => void;
    pageSize: number;
    setPageSize: (newCurrPage: number) => void;
    pageSizeOptions: number[];
    filterItemsByPage: <T>(items: T[]) => T[];
}

const usePagination = ({
    initialPage = 1,
    initialPageSize = DEFAULT_PAGE_SIZES[0],
}: UsePaginationProps): UsePaginationReturn => {
    const [currPage, setCurrPage] = useState(initialPage);
    const [pageSize, setPageSizeState] = useState(initialPageSize);

    const resetCurrPage = useCallback(() => {
        setCurrPage(initialPage);
    }, [initialPage]);

    const filterItemsByPage = <T>(items: T[]) => {
        return items.filter((_, index) => {
            const minIndex = pageSize * (currPage - 1);
            const maxIndex = currPage * pageSize;
            return index >= minIndex && index < maxIndex;
        });
    };

    const setPageSize = (newPageSize: number) => {
        resetCurrPage();
        setPageSizeState(newPageSize);
    };

    return {
        currPage,
        setCurrPage,
        resetCurrPage,
        pageSize,
        setPageSize,
        pageSizeOptions: DEFAULT_PAGE_SIZES,
        filterItemsByPage,
    };
};

export default usePagination;
